/**
 * be careful about splitting "." that may be a key in an array object lookup
 *
 * eg. a.{"id.ddd": "dd"}.ttt
 */
export const pathRegex = new RegExp(/\.(?=(?:[^{}]*\{[^{}]*\})*[^{}]*$)/g);

export function tryJSON(str?: string | null | undefined) {
  if (!str) {
    return undefined;
  }

  try {
    return JSON.parse(str);
  } catch (err) {
    return undefined;
  }
}

export function isArrayObjectMatch(obj?: string): obj is string {
  return Boolean(
    obj &&
    (obj.endsWith("}") || obj?.endsWith("\\}")) &&
    (obj.startsWith("{") || obj?.startsWith("\\{")),
  );
}

export function hasMatches(test: object) {
  return function internalHasOption(obj: object) {
    return Object.entries(test).every(
      ([key, val]) => Object.hasOwn(obj, key) && obj[key as keyof typeof obj] == val,
    );
  };
}
